import styled, { x } from '@xstyled/styled-components';
import React, { FC } from 'react';
import { useSpring } from '@react-spring/web';
import ChevronIcon from '~/assets/icons/chevron.svg';
import { Chevron } from './Chevron';

const ItemHeading = styled.h3`
  margin: 0;
  font: inherit;
  font-weight: inherit;
  width: 100%;
`;

const ItemButton = styled.button<{ $expanded?: boolean }>`
  border: none;
  background: ${p => (p.$expanded ? p.theme.colors.accentDark : 'transparent')};
  color: ${p => (p.$expanded ? p.theme.colors.white : p.theme.colors.black)};
  padding: 8px 16px;
  text-align: left;
  display: flex;
  border-radius: md;
  width: 100%;
  font: inherit;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid var(--color-accent-dk);
    outline-offset: 2px;
  }
`;

export const FaqItem: FC<{
  title: string;
  expanded?: boolean;
  onClick: () => void;
  children: React.ReactNode;
}> = ({ title, expanded, onClick, children }) => {
  const props = useSpring({
    to: { transform: !expanded ? 'rotate(90deg)' : 'rotate(-90deg)' },
    from: { transform: 'rotate(90deg)' }
  });

  return (
    <>
      <ItemHeading>
        <ItemButton
          $expanded={expanded}
          onClick={onClick}
          className="itemStyleForDarkTheme"
          aria-expanded={expanded ? 'true' : 'false'}
        >
          <x.span flex="1">{title}</x.span>
          <Chevron style={props}>
            <ChevronIcon />
          </Chevron>
        </ItemButton>
      </ItemHeading>
      {expanded && <div aria-live="polite">{children}</div>}
    </>
  );
};
